var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 32,
    viewBox: "0 0 49 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_398)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    transform: "translate(0.0437317)",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0437 23.5H31.0437",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0437 13.4999H17.0437L23.5031 9.6586C23.6643 9.55495 23.852 9.49984 24.0437 9.49984C24.2354 9.49984 24.4231 9.55495 24.5844 9.6586L31.0437 13.4999Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0437 15.5V21.5H28.0437V15.5",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0437 15.5V21.5H23.0437V15.5",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0437 15.5V21.5H18.0437V15.5",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    fill: "white",
    transform: "translate(0.0437317)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10_398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16.0437 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAccountIcon);
export default __webpack_public_path__ + "static/media/bank-account-icon.ca6a46df43ff5a7ca8979ac77dad1e5a.svg";
export { ForwardRef as ReactComponent };